import axios from 'axios'
import { getCookie } from "mpfe-utils"
import Util from "../_utils/util"
import { env as Environment } from "@/env"
const { queryString, queryStringByUrl } = Util
const TimeOut = 5000 // 设置超时时间

function getCommonHeader(param) {
      let referObj = queryString() // 当前页url参数

      let result = {
        clientType: 3, // 3: pc
        suv: getCookie("SUV"),
        pvId: window.sohuSpm.getCodes().e, // pvid为当前页面spm码的e码
        requestId: param?.requestId || getCookie("SUV") + '_' + new Date().getTime(),
        Openid: getCookie("SUV"),
        // refer参数（跳转页面url）
        referSpm: referObj.spm, // 当前页url上的spm
        referScm: queryStringByUrl(document.referrer).scm, // 来源页面url上的scm
        referPath: document.referrer.slice(0, 200), // 来源页面的path

        // referer参数，当前页面url
        refererSpm: param?.spm, // 当前页a.b.c.d.e
        refererScm: referObj.scm, // 当前页url上的scm参数
        refererPath: window.location.pathname, // 当前页path

        trans: referObj.trans,
        Authorization: window.focusUmabRefreshToken || '' // 焦点下存在focusUmabRefreshToken，用于账号同步
      }
      for (var p in result) {
        if (result[p] == undefined) {
          delete result[p]
        }
      }
      return result
}

axios.interceptors.response.use(res => {
    if (res.status === 200) {
        return Promise.resolve(res)
    } else {
        return Promise.reject(res)
    }
})

axios.defaults.withCredentials = true

const urlMap = {
    v2: {
        test: '//v2.sohu.com',
        pre: '//v2.sohu.com',
        prod: '//v2.sohu.com',
    },
    uis: {
        test: '//test-uis.mp.sohu.com',
        prod: '//uis.mp.sohu.com',
        pre: '//uis.mp.sohu.com',
    },
    discuss: {
        test: '//test-uis.mp.sohu.com/wap', //test-uis.mp.sohu.com/wap 测试环境
        prod: '//uis.mp.sohu.com/wap',
        pre: '//uis.mp.sohu.com/wap',
    },
    interaction: {
        test: '//test-uis.mp.sohu.com/comment',
        pre: '//uis.mp.sohu.com/comment',
        prod: '//uis.mp.sohu.com/comment',
    },
    ucenter: {
        test: '//test-uis.mp.sohu.com/v3/uc',
        pre: '//pre-uis.mp.sohu.com/v3/uc',
        prod: '//uis.mp.sohu.com/v3/uc',
    },
    card: {
        test: '//test.mp.sohu.com/fe',
        pre: '//v2.sohu.com/mpfe',
        prod: '//v2.sohu.com/mpfe',
    },
    search: {
        test: '//search.sohu.com',
        pre: '//search.sohu.com',
        prod: '//search.sohu.com',
    },
    article: {
        test: '//test-www.sohu.com/api/article_data',
        pre: '//pre-www.sohu.com/api/article_data',
        prod: '//v2.sohu.com/api/article_data',
    },
    focus_a: {
        test: '//test-www.focus.cn/api/article_data',
        pre: '//pre-www.focus.cn/api/article_data',
        prod: '//article.focus.cn/api/article_data',
    },
}

const axiosFactory = function(urlType, env, headers){ // 配置axios的工厂
    const config = {
        baseURL: urlMap[urlType][env],
        timeout: TimeOut
    }
    // 自定义header
    if(headers) config.headers = headers
    let instance = axios.create(config)
    return instance;
}

export const randomString = (e) => {
    e = e || 32;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
    for (let i = 0; i < e; i++)
        n += t.charAt(Math.floor(Math.random() * a));
    return n;
}

export const getDiscussInfo = (params)=>{  // 讨论信息的接口
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve,reject)=>{
        discussAxios.get('/vote/info',{params,headers: getCommonHeader(params)}).then(res=>{
            resolve(res.data)
        }).catch(error=>{
            if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1){ // 如果请求超时
                if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    // 超时上报
                    window.sohuSpm.sendAction({
                        acode: '9601',
                        clkParam: `spm:${params?.spm};interface:${urlMap.discuss[Environment]}/vote/info`
                    });
                }
            }
            else reject(error)
        })
    })

}

export const getDiscussInfoById = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/vote/info/id', {
            params,
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
                if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    // 超时上报
                    window.sohuSpm.sendAction({
                        acode: '9601',
                        clkParam: `spm:${params?.spm};interface:${urlMap.discuss[Environment]}/vote/info/id`
                    });
                }
            }
            else reject(error)
        })
    })
}
//  查询观点数据
export const getViewsInfoById = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/view/v2/list', {
            params,
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
//  讨论关闭反馈原因
export const reportVote = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/report/vote', params)
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
//  获取讨论观点
export const getView = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/view/v2/list', {
            params,
            headers: getCommonHeader(params)
        })
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 获取5条热门评论+10条最新评论
export const getHotComments = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/api/comments/load', {
            params,
            timeout: 5000
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 获取更多评论
export const getMoreComments = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/api/comments/pages', {
            params,
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 删除评论
export const deleteComment = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/comment/remove', {
            ...params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 评论点赞
export const likeComment = (params)=>{
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    let discussAxios = axiosFactory('discuss', Environment, headers);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/like', {
            ...params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 举报评论
export const reportComment = (params)=>{
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    let discussAxios = axiosFactory('interaction', Environment, headers);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/comments/report', {
            ...params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 图片上传
export const uploadImg = (data)=>{
    var match = document.cookie.match(/(^| )umab_access_token=([^;]+)/);
    var cookieToken = ''
    if (match) cookieToken = decodeURIComponent(match[2]);
    const headers = {
        'Authorization': cookieToken
    }
    let discussAxios = axiosFactory('uis', Environment, headers);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/vpd/file/imgUpload', data).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 发布评论
export const publishComment = (params)=>{
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    let discussAxios = axiosFactory('interaction', Environment, headers);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/comments/', params).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 获取封禁信息
export const getUserBannedInfo = ()=>{
    let axiosFn = axiosFactory('uis', Environment);
    return new Promise((resolve, reject) => {
        axiosFn.get('/comment/api/user', {
            params:{},
        })
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 获取用户信息（增加缓存请求的能力）
export const getUserInfo = (() => {
    const params = {
        appId: 100018,
        device: 'MPTCFEPCUSER',
    }
    let discussAxios = axiosFactory('ucenter', Environment)

    return () => {
        if (!window.EVENT_BUS.cachePromise) {
            window.EVENT_BUS.cachePromise = new Promise((resolve, reject) => {
                discussAxios
                    .get('/user/info', { params })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((error) => {
                        console.log('error', error)
                        if( window?.EVENT_BUS?.cachePromise) {
                            window.EVENT_BUS.cachePromise = null // 发生错误时清除缓存
                        }
                        reject(error)
                    })
            })
        }
        return window.EVENT_BUS.cachePromise
    }
})()

// 获取文章点赞数量
export const getlikeCount = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/api/topic/like/count', {
            params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })

}

// 点赞文章
export const addArticleLike = (params)=>{
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    let discussAxios = axiosFactory('discuss', Environment,headers);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/topic/like', {
            ...params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })

}
// 批量获取文章页评论数
export const getCommentCount = (params)=>{
    let axiosF = axiosFactory('interaction', Environment);
    return new Promise((resolve, reject) => {
        axiosF.get('/api/topics/count', {
            params
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 获取转载文章页信息
export const getReprintArticleInfo = (id)=>{
    let discussAxios = axiosFactory('v2', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get(`/article-service-api/article/${id}/lite`).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 发送投票
export const sendVote = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/view/v2/vote', params,{
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}
// 取消投票
export const cancelVote = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/community/change/state', params,{
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

// 获取功能卡信息
export const getCardInfo = (params)=>{
    let discussAxios = axiosFactory('card', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/card/get', {
            params,
            headers: {
                'Authorization': window.focusUmabRefreshToken || '',
                'tourist': getCookie('SUV')
            }
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}
// 同步游客文章点赞
export const syncLikeArticle = ()=>{
    let axiosFn = axiosFactory('uis', Environment);
    const params = {
        visitorId: getCookie('SUV')
    }
    return new Promise((resolve, reject) => {
        axiosFn.post('/wap/api/like/syncVisitor', params).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

// 获取搜索热词
export const getHotSearch = () => {
    let discussAxios = axiosFactory('search', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/search/hot').then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

// 获取剩余文章信息
export const getLastArticleInfo = (params) => {
    const { stage, displayMode } = params
    const uri = `${stage}`
    const p = {
        displayMode,
    }
    const isSohu = location.href.includes('sohu.com')
    const typeArticle = isSohu ? 'article' : 'focus_a'
    const articleAxios = axiosFactory(typeArticle, Environment)
    return new Promise((resolve, reject) => {
        articleAxios.get(uri, {params: p}).then(res => {
            console.log('res',res)
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 获取互动数量
export const getInteracitonCountApi = function () {
    const params = {
        sourceId: `mp_${window.pcArticleInfo?.news_id}`
    }
    let uisAxios = axiosFactory('uis', Environment);
    return new Promise((resolve, reject) => {
        uisAxios.get('/wap/api/static/topic', {
            params,
            headers: {
                'visitorid': getCookie("SUV")
            }
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 收藏
export const sendCollection = function (flag) {
    let status = flag ? 1 : 0
    const params = {
        sourceId: `mp_${window.pcArticleInfo?.news_id}`,
        displayStatus: status,
        topicLink: window?.location?.origin + window?.location?.pathname,
        topicTitle: window?.pcArticleInfo?.title
    }
    let uisAxios = axiosFactory('uis', Environment);
    return new Promise((resolve, reject) => {
        uisAxios.post('/wap/collect/', params).then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}